import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ProtocolDBService } from '../db/protocol-db-service';
import { ProtocolDto } from 'src/app/dtos/protocolDto';

@Injectable()
export class ProtocolResolver implements Resolve<ProtocolDto> {
  private protocolDbService = inject(ProtocolDBService);

  public resolve(route: ActivatedRouteSnapshot) {
    return this.protocolDbService.getProtocol(route.paramMap.get('inspectionKey'));
  }
}
